import { render, staticRenderFns } from "./StudentsList.vue?vue&type=template&id=a5d6b65a&"
import script from "./StudentsList.vue?vue&type=script&lang=js&"
export * from "./StudentsList.vue?vue&type=script&lang=js&"
import style0 from "./StudentsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports